// extracted by mini-css-extract-plugin
module.exports = {"featuredSection":"featuredInPress-module--featuredSection--MkuV6"};